<template>
  <div class="xsd_history">
    <div class="topContainer">
      <div class="topContainerInner">
        <div
            v-tracking="{module:'xsd_all',actionName: $trackConfig['xsd_all_goHome'],actionCode:'xsd_all_goHome'}"
            class="goIndexBtn"
            @click="goHome">
          回到标书对比首页
        </div>
      </div>
    </div>
    <div class="bodyContainer">
      <div class="history_title">
        历史记录
        <span class="warning-text">温馨提示：历史记录仅存储近24小时检查数据，以免记录丢失，请尽早导出数据自行存储。</span>
      </div>
      <el-table
          :data="tableData"
          height="250"
          stripe
          style="width: 100%"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div v-if="scope.row.zb.length" style="margin-bottom:5px "><span class="file_title">招标文件</span> <span> {{
                scope.row.zb[0]
              }}</span></div>
            <div v-for="(item,idx) in scope.row.tb" :key="idx" style="margin-bottom:5px;padding: 2px 10px; ">
              <span class="file_title"> 投标文件{{ idx + 1 }}</span> <span>{{ item.file_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="序号"
            type="index"
        >
        </el-table-column>
        <el-table-column
            label="项目名称"
            prop="check_name"
        >
        </el-table-column>
        <el-table-column
            label="文件类型"
            prop="type"
        >
        </el-table-column>
        <el-table-column label="检查日期" prop="create_time" width="200">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <span
                v-tracking="{module:'xsd_all',actionName: $trackConfig['xsd_all_history_check'],actionCode:'xsd_all_history_check'}"
                class="h_btn" :class="scope.row.flag ? 'disable_btn': ''"
                @click="go_result(scope.row)">查看{{scope.row.timestamp}}</span>
            <span
                v-tracking="{module:'xsd_all',actionName: $trackConfig['xsd_all_history_export'],actionCode:'xsd_all_history_export'}"
                class="h_btn"
                @click="export_result(scope.row)">导出</span>
            <span
                v-tracking="{module:'xsd_all',actionName: $trackConfig['xsd_all_history_del'],actionCode:'xsd_all_history_del'}"
                class="h_btn"
                @click="delrecord(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 5px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>

    </div>

  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {getHistory,delHistory,getExportFile,getResultHead} from "@/api/common";
export default {
  name: "history",
  data() {
    return {
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10

    }
  },
  mounted() {
    this.getHistory();

  },
  methods: {
    async getHistory() {
      let res= await getHistory({
        pageNo:this.currentPage,
        pageSize:this.pageSize
      });
       this.total = res.data.total;
       // res = this.$_.sortBy(res.data.records, "create_time")
       // res = res.reverse();
      this.tableData = this.$_.map(res.data.records, (item) => {
        const timestamp = Date.now();
        console.log(timestamp)
        const oneDayMs = 24 * 60 * 60 * 1000;
        const thirtyOneDaysMs = 31 * oneDayMs;
        item.flag = (timestamp - Math.floor(new Date(item.create_time).getTime())) > thirtyOneDaysMs;
        item.zb = this.$_.map(item.bid_doc, (_zb) => {
          return _zb.file_name;
        })
        item.tb = [];
        this.$_.map(item.docs, (_tb) => {
          item.tb = [...item.tb, ..._tb.path]
        })
        return item
      })
    },

    goHome() {
      this.$router.push({
        name: "Home",
        params: {
          init: true
        }
      })
    },
    async go_result(row) {
      if(row.flag){
        return;
      }
      if (row.type == 'pdf') {
        if (["1"].includes(row.deduction)) {
          let res = await getResultHead({
            project: row.project,
            sign_name: row.sign_name
          });
          let data = res.data.resultHead?res.data.resultHead:{};
          this.set_projectId_pdf(row.project);
          this.set_signName_pdf(row.sign_name);
          this.setEvaluationData_pdf(data.evaluation);
          await this.$router.push("/pdfResult");
        } else {
          this.set_projectId_pdf(row.project);
          this.set_signName_pdf(row.sign_name);
          await this.$router.push("/pdfMiddleResult");
        }
      } else {
        if(row.deduction == 1){
          let res = await getResultHead({
            project: row.project,
            sign_name: row.sign_name
          })
          let data = res.data.resultHead?res.data.resultHead:{};
          this.setBaseData(data.base_info);
          this.setEvaluationData(data.evaluation);
          this.set_projectId_word(data.project);
          this.set_signName_word(data.sign_name);
          this.setProcessData(data.process_status);
          await this.$router.push("/wordResult")
        }else{
          this.set_projectId_word(row.project);
          this.set_signName_word(row.sign_name);
          await this.$router.push("/wordMiddleResult")
        }
      }
    },
    async export_result(row) {
      if(row.deduction != 1){
        this.$util.warning("请先充值完成结算！");
      }else{
        let res = await getExportFile({
          project: row.project,
          sign_name: row.sign_name
        })
        let url = res.data;
        window.location = url;
      }
    },
    async delrecord(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
          let res = await delHistory({
            project: row.project,
            sign_name: row.sign_name
          });
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        await this.getHistory();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getHistory();

    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getHistory();
    },
    ...mapMutations('word', ['setProcessData', 'setEvaluationData', 'setBaseData', "set_signName_word", "set_projectId_word"]),
    ...mapMutations("pdf", {
      setProcessData_pdf: "setProcessData",
      setEvaluationData_pdf: "setEvaluationData",
      set_projectId_pdf: "set_projectId_pdf",
      set_signName_pdf: "set_signName_pdf"
    })
  },
  computed: {
    ...mapState('word', ['projectId', "sign_name", "baseData", "processData", "evaluationData", "hasImg"]),
    ...mapState("user", ['serviceInfo'])
  }
}
</script>

<style lang="scss" scoped>

.xsd_history {
  height: 100%;
  width: 100%;
  background-color: #F2F5FB;
  display: flex;
  flex-direction: column;

  .history_title {
    height: 30px;
    line-height: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 10px;
    position: relative;
    padding-left: 15px;

    &::before {
      content: "";
      width: 4px;
      height: 16px;
      background: #224AE3;
      position: absolute;
      left: 0;
      top: 7px;

    }
    .warning-text{
      font-weight: normal;
      font-size: 14px;
      margin-left: 12px;
      color:red;
    }
  }

  .topContainer {
    background-image: url("~@/assets/image/topbg.png");
    background-repeat: no-repeat;
    height: 56px;

    .topContainerInner {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      height: 56px;

      .goIndexBtn {
        line-height: 56px;
        font-size: 14px;
        background-image: url("~@/assets/image/shouye.png");
        background-repeat: no-repeat;
        background-size: 16px;
        background-position: 0px center;
        padding-left: 25px;
        cursor: pointer;
      }
    }

    //width: 1200px;
    //margin: 60px auto 0 auto;
  }

  .bodyContainer {
    width: 1200px;
    flex: 1;
    height: 1px;
    background: #fff;
    margin: 10px auto 10px auto;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 15px 32px;
    display: flex;
    flex-direction: column;
  }

  .h_btn {
    color: #224AE3;
    cursor: pointer;
    margin: 0 10px;
  }

  .disable_btn {

    /* 阻止所有鼠标事件 */
    //pointer-events: none;
    color: #6c757d;
    opacity: 0.65;
    cursor: not-allowed;
  }

  .file_title {
    display: inline-block;
    height: 25px;
    line-height: 25px;
    border: 1px solid #224AE3;
    padding: 0px 10px;
    border-radius: 15px;
    color: #224AE3;
    margin-right: 16px;
  }

  .paginationContainer {
    height: 30px;
    width: 1200px;
    text-align: right;
    margin: 10px 0 0 0;
    //margin: 10px auto;
  }
}

::v-deep {
  .el-table {
    color: #000;
  }

  .el-table__header-wrapper {
    tr {
      background-color: #F5F6F8 !important;
    }

    th {
      background-color: #F5F6F8 !important;

    }
  }

  .el-table {
    height: 100% !important;
    display: flex;
    flex-direction: column;

    .el-table__body-wrapper {
      flex: 1;
      height: 1px;
    }

    .el-table__expanded-cell {
      background: #F2F5FD;

      &:hover {
        background: #F2F5FD !important;

      }
    }

  }

}
</style>
